<template>
  <div>
    <label class="block text-sm font-medium" :class="labelStyling">{{
      label
    }}</label>
    <button
      type="button"
      :class="[finalBackgroundColorStyling, { 'mt-1': label }]"
      class="relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2"
      aria-pressed="false"
      @click="toggle()"
    >
      <span
        aria-hidden="true"
        :class="[
          { 'translate-x-5': modelValue },
          { 'translate-x-0': !modelValue },
        ]"
        class="translate-x-0 pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200"
      ></span>
    </button>
  </div>
</template>

<script>
export default {
  emits: ["update:modelValue"],
  name: "UiToggle",
  props: {
    modelValue: {
      type: Boolean,
    },
    labelStyling: {
      type: String,
      default: "text-gray-700",
    },
    label: {
      type: String,
      required: false,
    },
    disabledBackgroundColorStyling: {
      type: String,
      default: "bg-gray-200",
    },
    enabledBackgroundColorStyling: {
      type: String,
      default: "bg-light-blue-500",
    },
    focusColorStyling: {
      type: String,
      default: "focus:ring-light-blue-500",
    },
  },
  computed: {
    finalBackgroundColorStyling() {
      return this.modelValue
        ? this.enabledBackgroundColorStyling
        : this.disabledBackgroundColorStyling;
    },
  },
  methods: {
    toggle() {
      this.$emit("update:modelValue", !this.modelValue);
    },
  },
};
</script>